// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixWindow from 'wix-window';
import wixData from 'wix-data';
import { getPostsByCategory } from 'backend/postsFetcher';
//import { getRecentPosts } from 'backend/postsFetcher'

const IS_DESKTOP = wixWindow.formFactor === "Desktop";
const [INITIAL_POST_LIMIT, FULL_POST_LIMIT] = IS_DESKTOP ? [4, 9] : [2, 5];
const SPOTLIGHT_LIMIT = 3;
let rightbg,leftbg;
const defaultPostsLimit = 10;
function preparePostsData(firstArray, secondArray) {
	return firstArray.reduce((acc, item) => {
		const {_id} = item;
		const secondArrayItem = secondArray.find(({post}) => post === _id);
		if (secondArrayItem) {
			delete secondArrayItem.post;
			delete item.plainContent;
			acc.push(Object.assign(item, secondArrayItem));
		}
		return acc;
	}, []);
}

async function getRecentPosts(limit) {
	const queryLimit = limit || defaultPostsLimit;

	try {
		// Fetch the recent posts
		const recentPosts = await wixData.query('Blog/Posts')
			.descending('publishedDate')
			.limit(queryLimit)
			.find();

		// Get ids of the recent posts
		const postIds = recentPosts.items.map(post => post._id);

		// Get the extra post info
		let extraPostsInfoData = await wixData.query('Extra_Post_Info')
			.include('mainCategory')
			.hasSome("post", postIds)
			.find();

		// Merge by joining the 2 arrays
		return preparePostsData(recentPosts.items, extraPostsInfoData.items);
	} catch (e) {
		console.log('ERROR: ' + JSON.strigify(e));
		return [];
	}
}
$w.onReady(function () {
	 leftbg = $w('#column83').background.src;
	 rightbg = $w('#column84').background.src;
	 $w('#column84').background.src ="";
	 $w('#column83').background.src = "";
	if (wixWindow.rendering.env !== "browser") {
		return getRecentPosts(INITIAL_POST_LIMIT).then(showRecentPosts);
	}

	getRecentPosts(FULL_POST_LIMIT).then(recentPostsData => {
		showRecentPosts(recentPostsData.slice(0, FULL_POST_LIMIT));
		/*$w("#box9").onViewportEnter(() => {
			showRecentPosts(recentPostsData);
		});*/
	});

	fetchSpotlight1($w('#spotlight1Title'), $w('#spotlight1Repeater'));
});

function showRecentPosts(recentPostsData) {
	if (recentPostsData.length > 0) {
		// Set the recent posts on the feed
		const $repeater = $w('#recentPostsRepeater');
		$repeater.onItemReady(recentPostsRepeaterItemReadyHandler);
		
		$repeater.data = recentPostsData;
		$repeater.show();
	}
}

/*
 * async function fetchSpotlight
 * Description: fetches spotlight data
 * Notes: it says spotlight1 cause we had 2 spotlights in the original plan
 */
async function fetchSpotlight1(title, repeater) {
	// Get a category which is marked with spotlight 1
	const spotlightCateogries = await wixData.query('Categories')
		.eq('spotlight', 1)
		.limit(1)
		.find();

	if (spotlightCateogries.items.length > 0) {
		// Get the spotlight data
		const spotlightCateogry = spotlightCateogries.items[0];
		const spotlightData = await getPostsByCategory(spotlightCateogry._id, SPOTLIGHT_LIMIT);

		if (spotlightData.length > 0) {
			// Set spotlight title
			title.text = spotlightCateogry.title;
			title.show();

			// Set the spotlight images (some elements are for hover effects)
			setHover(spotlightData[0], $w('#spotlight1PostMainImage1'), $w('#spotlight1PostMainImage1Hover'));
			setHover(spotlightData[1], $w('#spotlight1PostMainImage2'), $w('#spotlight1PostMainImage2Hover'));
			setHover(spotlightData[2], $w('#spotlight1PostMainImage3'));

			repeater.onItemReady(spotlight1RepeaterItemReadyHandler);
			repeater.data = spotlightData;
			repeater.show()
		}
	}
}

function setHover({coverImage, postPageUrl, title}, $spotlight1PostMainImage, $spotlight1PostMainImage2Hover) {
	$spotlight1PostMainImage.src = coverImage;
	$spotlight1PostMainImage.link = postPageUrl;
	$spotlight1PostMainImage.alt = title;
	if ($spotlight1PostMainImage2Hover) {
		$spotlight1PostMainImage2Hover.src = coverImage;
		$spotlight1PostMainImage2Hover.link = postPageUrl;
		$spotlight1PostMainImage2Hover.alt = title;
	}
}

/*
 * function spotlight1RepeaterItemReadyHandler
 * Description: An onItemReady handler for the spotlight repeater
 * Notes: it says spotlight1 cause we had 2 spotlights in the original plan
 */
function spotlight1RepeaterItemReadyHandler($item, {title, excerpt, mainCategory, postPageUrl}) {
	// Set title
	$item('#spotlight1PostTitle').text = title;

	//Set Excerpt
	$item('#spotlight1PostExcerpt').text = excerpt;

	// Set Category
	const $mainCategoryButton = $item('#spotlight1PostMainCategoryButton');
	$mainCategoryButton.label = mainCategory.title;
	$mainCategoryButton.link = mainCategory['link-categories-all'];

	// Set link
	$item('#spotlight1PostButton').link = postPageUrl;
}

/*
 * function recentPostsRepeaterItemReadyHandler
 * Description: An onItemReady handler for the recent posts repeater
 */
function recentPostsRepeaterItemReadyHandler($item, {title, coverImage, mainCategory, excerpt, postPageUrl}) {
	// Set title
	$item('#postTitle').text = title;

	// Set Image
	$item('#postImage').src = coverImage;

	// Set Category
	const $mainCategoryButton = $item('#postMainCategoryButton');
	$mainCategoryButton.label = mainCategory.title;
	$mainCategoryButton.link = mainCategory['link-categories-all'];

	// Set Excerpt (only on desktop)
	if (IS_DESKTOP) {
		const $excerpt = $item('#postExcerpt');
		$excerpt.text = excerpt;
		$excerpt.show();
	}
	// Set button
	$item('#postBoxButton').link = postPageUrl;
	$item('#postButton').link = postPageUrl;
	

}

/*
 * Design functions (hovers)
 */

/*
 * On mouse in on repeater item container - show post box, hide image, show post excerpt
 */


export function container1_mouseIn(event) {
	if (IS_DESKTOP) {
		const $item = $w.at(event.context);
		$item("#postBox").show();
		$item('#postImage').hide();
		$item("#postExcerpt").show();
	}
}

export function container1_mouseOut(event) {
	if (IS_DESKTOP) {
		const $item = $w.at(event.context);
		$item("#postBox").hide();
		$item('#postImage').show();
		$item("#postExcerpt").hide();
	}
}

export function celebrateHoverBox_mouseIn(event) {
	if (IS_DESKTOP) {
		const $item = $w.at(event.context);
		$item("#mediaPlayer01").show();
	}
}

export function celebrateHoverBox_mouseOut(event) {
	if (IS_DESKTOP) {
		const $item = $w.at(event.context);
		$item("#mediaPlayer01").hide();
	}
}

export function playgroundHoverBox_mouseIn(event) {
	if (IS_DESKTOP) {
		const $item = $w.at(event.context);
		$item("#mediaPlayer02").show();
	}
}

export function playgroundHoverBox_mouseOut(event) {
	if (IS_DESKTOP) {
		const $item = $w.at(event.context);
		$item("#mediaPlayer02").hide();
	}
}

export function newSkillHoverBox_mouseIn(event) {
	const $item = $w.at(event.context);
	$item("#mediaPlayer03").show();
}

export function newSkillHoverBox_mouseOut(event) {
	if (IS_DESKTOP) {
		const $item = $w.at(event.context);
		$item("#mediaPlayer03").hide();
	}
}

export function spotlightHoverBox_mouseIn(event) {
	const $item = $w.at(event.context);
	$item("#spotlight1PostMainImage2Hover").show();

}

export function spotlightHoverBox_mouseOut(event) {
	if (IS_DESKTOP) {
		const $item = $w.at(event.context);
		$item("#spotlight1PostMainImage2Hover").hide();
	}
}

export function spotlightHoverBox02_mouseIn(event) {
	if (IS_DESKTOP) {
		const $item = $w.at(event.context);
		// $item("#spotlight1PostMainImage3Hover").show();
		$item("#spotlight1PostMainImage2Hover").show();
	}
}

export function spotlightHoverBox02_mouseOut(event) {
	const $item = $w.at(event.context);
	// $item("#spotlight1PostMainImage3Hover").hide();
	$item("#spotlight1PostMainImage2Hover").hide();
}

export function spotlightHoverBox01_mouseIn(event) {
	if (IS_DESKTOP) {
		const $item = $w.at(event.context);
		$item("#spotlight1PostMainImage1Hover").show();
	}
}

export function spotlightHoverBox01_mouseOut(event) {
	if (IS_DESKTOP) {
		const $item = $w.at(event.context);
		$item("#spotlight1PostMainImage1Hover").hide();
	}
}



export function column84_mouseIn(event) {
	$w('#column84').background.src = rightbg;
}

export function column84_mouseOut(event) {
	$w('#column84').background.src = "";
}

export function column83_mouseIn(event) {
	$w('#column83').background.src = leftbg; 
}

export function column83_mouseOut(event) {
	$w('#column83').background.src = "";
}
